import { useEffect, useState } from 'react';
import { db } from '../firebase';
import { fetchSyllabusCatalog, SyllabusCatalog } from '../services/syllabusCatalog';

export const useSyllabusCatalog = (academicYear = 'all') => {
  const [catalog, setCatalog] = useState<SyllabusCatalog | null>(null);
  const [loading, setLoading] = useState(Boolean(academicYear));
  const [valid, setValid] = useState(false);

  useEffect(() => {
    let cancelled = false;
    if (!academicYear) { setCatalog(null); setValid(false); setLoading(false); return () => undefined; }
    setLoading(true);
    fetchSyllabusCatalog(db, academicYear).then((next) => {
      if (cancelled) return;
      setCatalog(next);
      setValid(Boolean(next));
    }).catch(() => {
      if (!cancelled) { setCatalog(null); setValid(false); }
    }).finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, [academicYear]);

  return { catalog, loading, valid };
};
